import React, { useState, useEffect } from "react";
import { matchPath, useLocation } from "react-router-dom";
import {
  horizontalMenus,
  HorizontalMenuType,
} from "../../routes/horizontalmenus";
import { MenuContainer, MenuItemStyled, MenuLink } from "./styles";

interface HorizontalMenuItem extends HorizontalMenuType {
  isParentWithChildren?: boolean;
}

const getHorizontalMenuItems = (): HorizontalMenuItem[] => {
  return horizontalMenus.map((item) => {
    if (item.to) {
      return { ...item, isParentWithChildren: false };
    } else if (item.subRoutes && item.subRoutes.length > 0) {
      return {
        title: item.title,
        to: item.subRoutes[0].to,
        icon: item.icon,
        isParentWithChildren: true,
      };
    }
    return item;
  });
};

export const HorizontalMenu: React.FC = () => {
  const location = useLocation();
  const menuItems = getHorizontalMenuItems();

  const isActive = (item: HorizontalMenuItem): boolean => {
    if (item.to && Array.isArray(item.to)) {
      return item.to.some(
        (path) => !!matchPath({ path, end: true }, location.pathname)
      );
    }

    if (item.isParentWithChildren) {
      const original = horizontalMenus.find((sub) => sub.title === item.title);
      if (original && original.subRoutes) {
        return original.subRoutes.some(
          (child) =>
            child.to &&
            child.to.some(
              (path) => !!matchPath({ path, end: true }, location.pathname)
            )
        );
      }
    }
    return false;
  };

  return (
    <MenuContainer>
      {menuItems.map((item) => (
        <MenuItemStyled key={item.title} $active={isActive(item)}>
          <MenuLink $active={isActive(item)} to={item.to[0]}>
            {item.icon} {item.title}
          </MenuLink>
        </MenuItemStyled>
      ))}
    </MenuContainer>
  );
};
